
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class DifficultyIndicator extends Vue {
  @Prop({default: 0, required: true}) difficultyLevel!: number | null;
  @Prop({default: false, required: false}) isTransparent!: boolean;
  @Prop({default: false, required: false}) isLarge! : boolean;

  colors: string[] = ['#b8e994', '#20bf6b', '#ffbe76', '#fd7272','#d6a2e8']

  get textDifficulty() {
    switch (this.difficultyLevel) {
      case null:
        return 'Générique'
      case 0:
        return 'Intermédiaire';
      case 1:
        return 'Novice';
      case 2:
        return 'Débutant';
      case 3:
        return 'Intermédiaire';
      case 4:
        return 'Avancé';
      case 5:
        return 'Pro';
    }
    return 'difficulty-0';
  }
}
